import type { JiraContextData } from '../controllers/use-ai-create-project-context/types';

/**
 * Gets the number of parent and child issues created from the draft work items.
 * @param draftWorkItems - The draft work items.
 * @returns The number of parent and child issues created.
 */
export const getNumberIssuesFromDraftWorkItems = (draftWorkItems: JiraContextData[]): number => {
	const childWorkItems = draftWorkItems.flatMap((workItem) => workItem.childWorkItems ?? []);
	return draftWorkItems.length + childWorkItems.length;
};
